<div class="row">
    <div class="col-xl-5">
        <div class="card mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-pill badge-warning">Warning</span>
                </div>
                <div class="bg-composed-wrapper bg-midnight-bloom border-0">
                    <div class="bg-composed-img-2 bg-composed-wrapper--image rounded"></div>
                    <div class="bg-composed-wrapper--content text-light p-5"><h4 class="font-size-xl font-weight-bold mb-2">
                        Knowledge Base Software</h4>
                        <p class="opacity-6 font-size-md mb-3"> Sed ut perspiciatis unde omnis iste natus error sit
                            voluptatem. </p>
                        <button class="btn btn-danger text-nowrap px-4 text-uppercase font-size-sm">
                            <small class="font-weight-bold">Contact us</small>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body text-center card-body-avatar">
                <div class="avatar-icon-wrapper d-120">
                    <div class="avatar-icon rounded-circle">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar6.jpg"/>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-alternate text-nowrap text-left table-hover mb-0 table-borderless">
                        <thead class="thead-light">
                        <tr>
                            <th class="pt-0" style="width: 40%;">Employee</th>
                            <th class="pt-0 text-center">Status</th>
                            <th class="pt-0 text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="avatar-icon-wrapper mr-2">
                                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/>
                                        </div>
                                    </div>
                                    <div>
                                        <a [routerLink]="" class="font-weight-bold text-black" title="...">Shanelle
                                            Wynn</a>
                                        <span class="text-black-50 d-block">UI Engineer, Apple Inc.</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span class="badge badge-warning h-auto py-0 px-3">Pending</span>
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-neutral-first">Chat</button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="avatar-icon-wrapper mr-2">
                                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/>
                                        </div>
                                    </div>
                                    <div>
                                        <a [routerLink]="" class="font-weight-bold text-black" title="...">Beck
                                            Simpson</a>
                                        <span class="text-black-50 d-block">Frontend Developer</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span class="badge badge-success h-auto py-0 px-3">Completed</span>
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-neutral-first">Chat</button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="avatar-icon-wrapper mr-2">
                                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar3.jpg"/>
                                        </div>
                                    </div>
                                    <div>
                                        <a [routerLink]="" class="font-weight-bold text-black" title="...">Regan
                                            Norris</a>
                                        <span class="text-black-50 d-block">Senior Project Manager</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span class="badge badge-danger h-auto py-0 px-3">Declined</span>
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-neutral-first">Chat</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-7">
        <div class="card mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges card-badges-top">
                    <span class="badge badge-pill badge-info">NEW</span>
                </div>
                <div class="bg-composed-wrapper bg-vicious-stance border-0">
                    <div class="bg-composed-img-3 bg-composed-wrapper--image"></div>
                    <div class="bg-composed-wrapper--content text-center text-light p-5">
                        <h1 class="display-3 font-weight-bold mb-0">
                            Knowledgebase
                        </h1>
                    </div>
                </div>
            </div>
            <div class="card-body text-center card-body-button">
                <div class="card-body-button-wrapper">
                    <button class="btn btn-lg btn-success btn-pill text-nowrap px-5 shadow-none border-3 border-white">
                        Send us a message
                    </button>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="bg-secondary p-3 text-center rounded">
                            <div>
                                <fa-icon [icon]="['far', 'user']" class="font-size-xxl text-warning"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg">2,345</b>
                                <span class="text-black-50 d-block">users</span>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="bg-secondary p-3 text-center rounded">
                            <div>
                                <fa-icon [icon]="['fas', 'lemon']" class="font-size-xxl text-success"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg">$3,586</b>
                                <span class="text-black-50 d-block">sales</span>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="bg-secondary p-3 text-center rounded">
                            <div>
                                <fa-icon [icon]="['far', 'chart-bar']" class="font-size-xxl text-info"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg">$9,693</b>
                                <span class="text-black-50 d-block">revenue</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table text-left mt-4 text-nowrap table-alternate table-hover mb-0 table-borderless">
                        <tbody>
                        <tr>
                            <td>
                                <div class="d-flex">
                                    <div class="custom-checkbox custom-control align-self-center">
                                        <input class="custom-control-input" id="inputCheckbox188" type="checkbox">
                                        <label class="custom-control-label" for="inputCheckbox188">&nbsp;</label>
                                    </div>
                                    <div><a [routerLink]="" class="font-weight-bold text-black" title="...">Inez
                                        Conley</a><span
                                            class="text-black-50 d-block">Project Manager</span></div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span class="font-weight-bold">$18,386</span>
                            </td>
                            <td class="text-center">
                                <span class="text-danger font-weight-bold">-6,310</span>
                            </td>
                            <td class="text-center">
                                <span class="badge badge-warning">Pending</span>
                            </td>
                            <td class="text-right">
                                <div class="d-flex align-items-center justify-content-end">
                                    <div [countUp]="584" class="font-weight-bold font-size-lg pr-2"></div>
                                    <fa-icon [icon]="['fas', 'arrow-down']"
                                             class="font-size-sm opacity-5"></fa-icon>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="d-flex">
                                    <div class="custom-checkbox custom-control align-self-center">
                                        <input class="custom-control-input" id="inputCheckbox177" type="checkbox">
                                        <label class="custom-control-label" for="inputCheckbox177">&nbsp;</label>
                                    </div>
                                    <div><a [routerLink]="" class="font-weight-bold text-black" title="...">Adyan
                                        Sosa</a><span
                                            class="text-black-50 d-block">User Experience Designer</span></div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span class="font-weight-bold">$6,356</span>
                            </td>
                            <td class="text-center">
                                <span class="text-warning">-374</span>
                            </td>
                            <td class="text-center">
                                <span class="badge badge-first">Waiting</span>
                            </td>
                            <td class="text-right">
                                <div class="d-flex align-items-center justify-content-end">
                                    <div [countUp]="483" class="font-weight-bold font-size-lg pr-2"></div>
                                    <fa-icon [icon]="['fas', 'arrow-up']"
                                             class="font-size-sm opacity-5"></fa-icon>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="d-flex">
                                    <div class="custom-checkbox custom-control align-self-center">
                                        <input class="custom-control-input" id="inputCheckbox166" type="checkbox">
                                        <label class="custom-control-label" for="inputCheckbox166">&nbsp;</label>
                                    </div>
                                    <div><a [routerLink]="" class="font-weight-bold text-black" title="...">Beck
                                        Simpson</a><span class="text-black-50 d-block">Senior Consultant</span></div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span class="font-weight-bold">$16,281</span>
                            </td>
                            <td class="text-center">
                                <span class="text-success">+684</span>
                            </td>
                            <td class="text-center">
                                <span class="badge badge-success">Done</span>
                            </td>
                            <td class="text-right">
                                <div class="d-flex align-items-center justify-content-end">
                                    <div class="font-weight-bold font-size-lg pr-2"> $12,23M</div>
                                    <fa-icon [icon]="['fas', 'arrow-up']"
                                             class="font-size-sm opacity-5"></fa-icon>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
